export default __webpack_public_path__ + "static/media/download-arrow.11eb35c3.svg";